// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.capture-step .viewport
{
	border: solid 1px var(--survey-border-color-strongest);
	height: 497px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.capture-step .duration-indicator
{
	padding: 10px;
	color: var(--survey-text-color-5);
}

.capture-step .capture-button
{
	margin-top: 10px !important;
}

.capture-step .preview
{
	max-height: 100%;
	max-width: 100%;
}

.capture-step [type="file"]
{
	border: 0;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	overflow: hidden;
	padding: 0;
	position: absolute !important;
	white-space: nowrap;
	width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/Survey/Steps/CaptureStep.css"],"names":[],"mappings":";AACA;;CAEC,sDAAsD;CACtD,aAAa;CACb,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;CACb,iCAAiC;AAClC;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;CAEC,SAAS;CACT,sBAAsB;CACtB,WAAW;CACX,gBAAgB;CAChB,UAAU;CACV,6BAA6B;CAC7B,mBAAmB;CACnB,UAAU;AACX","sourcesContent":["\n.capture-step .viewport\n{\n\tborder: solid 1px var(--survey-border-color-strongest);\n\theight: 497px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.capture-step .duration-indicator\n{\n\tpadding: 10px;\n\tcolor: var(--survey-text-color-5);\n}\n\n.capture-step .capture-button\n{\n\tmargin-top: 10px !important;\n}\n\n.capture-step .preview\n{\n\tmax-height: 100%;\n\tmax-width: 100%;\n}\n\n.capture-step [type=\"file\"]\n{\n\tborder: 0;\n\tclip: rect(0, 0, 0, 0);\n\theight: 1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute !important;\n\twhite-space: nowrap;\n\twidth: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
